package com.wintermar.inspection.feature.util.inspection_status

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.size
import androidx.compose.material3.Icon
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import com.wintermar.inspection.core.ui.component.TextBodyTiny
import com.wintermar.inspection.core.ui.theme.AppDimension
import com.wintermar.inspection.core.ui.theme.LocalAppTheme
import com.wintermar.inspection.core.ui.util.modifier.badge
import com.wintermar.inspection.graphql.type.InspectionStatus
import org.jetbrains.compose.resources.painterResource

@Composable
fun InspectionStatusView(
    status: InspectionStatus,
    asBadge: Boolean = false,
    dimension: AppDimension = LocalAppTheme.current.dimension
) {
    val variant = status.toVariant()

    Row(
        modifier = if (!asBadge) Modifier
        else Modifier.badge(
            backgroundColor = variant.backgroundColor,
            borderColor = variant.borderColor
        ),
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.spacedBy(
            dimension.spacing.space2
        )
    ) {
        variant.icon?.let {
            Icon(
                painter = painterResource(it),
                contentDescription = variant.label,
                tint = variant.iconColor ?: Color.Transparent,
                modifier = Modifier.size(dimension.size.icon.xs)
            )
        }

        TextBodyTiny(
            text = variant.label,
            color = { variant.labelColor },
            bold = true
        )
    }
}
